import React from "react";
// TODO: Add react-helmet-async when React 19 support is available for SEO meta tags

import Icon from "@mdi/react";
import { mdiEmailOutline } from "@mdi/js";
import { useAuth } from "../contexts/AuthContext";
import StoreBanner from "../components/store-banner";
import "./Uploads.css"; // Reuse the same styling
import packageInfo from "../../package.json";

// Import existing assets
import logoImage from "../assets/dance_locale_3-200h.png";

const Contact = () => {
    const { user, logout } = useAuth();

    const handleLogout = () => {
        logout();
    };

    const handleEmailClick = () => {
        window.location.href = "mailto:support@dancelocale.com?subject=Dance Localé Web Support Request";
    };

    return (
        <div className="dashboard-container org-console contact-page">
                        {/* TODO: Add SEO meta tags when react-helmet-async supports React 19
                Title: "Contact - Dance Locale" */}

            {/* Header using the same structure as other pages */}
            <div data-role="Header" className="home-header-container">
                <header className="home-header">
                    <a href="/" className="home-logo1">
                        <img alt="logo" src={logoImage} className="home-image1" />
                        <span className="nav-wordmark">Dance Localé</span>
                    </a>
                    <div className="home-menu1">
                        <a href="/" className="home-text10" style={{ textDecoration: "none" }}>
                            Home
                        </a>
                        {user ? (
                            <>
                                {user.organisationId && (
                                    <a
                                        href="/dashboard"
                                        className="home-text12"
                                        style={{ cursor: "pointer", textDecoration: "none" }}>
                                        Dashboard
                                    </a>
                                )}
                                <a
                                    href="/my-hub"
                                    className="home-text12"
                                    style={{ cursor: "pointer", textDecoration: "none" }}>
                                    My Hub
                                </a>
                                <button onClick={handleLogout} className="home-text13" style={{ cursor: "pointer" }}>
                                    Logout
                                </button>
                            </>
                        ) : (
                            <>
                                <a
                                    href="/login"
                                    className="home-text12"
                                    style={{ cursor: "pointer", textDecoration: "none" }}>
                                    Login
                                </a>
                                <span className="home-text13" style={{ color: "#ff5f25" }}>
                                    Contact
                                </span>
                            </>
                        )}
                    </div>
                    <div className="home-container11">
                        <StoreBanner />
                    </div>
                </header>
            </div>

            {/* Main content using AdminConsole structure */}
            <div className="dashboard-main">
                <div className="dashboard-content-wrapper">
                    <div className="dashboard-header-card">
                        <h1 className="admin-console-title">Contact Dance Localé</h1>
                        <p className="admin-console-description">
                            We're here to help! Get in touch with our support team for any questions or assistance.
                        </p>

                        {/* Contact Information Section */}
                        <div className="admin-console-section">
                            <div className="admin-console-section-header">
                                <h2 className="admin-console-section-title">Get in Touch</h2>
                            </div>

                            <div className="admin-console-instructions">
                                <h3 className="admin-console-instructions-title">Support Email</h3>
                                <div style={{ textAlign: "center", marginBottom: "2rem" }}>
                                    <button
                                        className="contact-email-btn"
                                        onClick={handleEmailClick}>
                                        <Icon path={mdiEmailOutline} size={1} color="var(--dl-color-purple-default)" />
                                        <span>support@dancelocale.com</span>
                                    </button>
                                    {/* Version information */}
                                    <div style={{ textAlign: "center", marginTop: "1rem" }}>
                                        <p
                                            style={{
                                                fontSize: "0.875rem",
                                                color: "#6b7280",
                                                margin: "0",
                                            }}>
                                            Note for your email please add the Website version: {packageInfo.version}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* What We Can Help With Section */}
                        <div className="admin-console-section">
                            <div className="admin-console-section-header">
                                <h2 className="admin-console-section-title">How We Can Help</h2>
                            </div>

                            <div className="admin-console-instructions">
                                <h3 className="admin-console-instructions-title">We're Here to Assist With</h3>
                                <div className="admin-console-instructions-list">
                                    <div className="admin-console-instruction-item">
                                        <span className="admin-console-instruction-number">1</span>
                                        <span>
                                            <strong>App Support:</strong> Help with using the Dance Localé app, finding
                                            events, or setting up your profile.
                                        </span>
                                    </div>
                                    <div className="admin-console-instruction-item">
                                        <span className="admin-console-instruction-number">2</span>
                                        <span>
                                            <strong>Event Organizer Support:</strong> Assistance with connecting your
                                            Facebook page, importing events, or managing your listings.
                                        </span>
                                    </div>
                                    <div className="admin-console-instruction-item">
                                        <span className="admin-console-instruction-number">3</span>
                                        <span>
                                            <strong>Technical Issues:</strong> Report bugs, app crashes, or other
                                            technical problems you're experiencing.
                                        </span>
                                    </div>
                                    <div className="admin-console-instruction-item">
                                        <span className="admin-console-instruction-number">4</span>
                                        <span>
                                            <strong>General Inquiries:</strong> Questions about our service, partnership
                                            opportunities, or feedback about the platform.
                                        </span>
                                    </div>
                                    {/* NEW: Data Deletion Support Point */}
                                    <div className="admin-console-instruction-item">
                                        <span className="admin-console-instruction-number">5</span>
                                        <span>
                                            <strong>Data Deletion Requests:</strong> You can delete your account
                                            yourself from Settings ("Request account deletion") on the web, or from the
                                            Account section in the mobile app. For removal of specific data, or if you
                                            need help with deletion, email us with "Account Deletion Request" in your
                                            subject line and your registered email address for verification.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* What to Include Section */}
                        <div className="admin-console-section">
                            <div className="admin-console-section-header">
                                <h2 className="admin-console-section-title">What to Include in Your Message</h2>
                            </div>

                            <div className="admin-console-instructions">
                                <p style={{ fontSize: "1rem", lineHeight: "1.6", marginBottom: "1rem" }}>
                                    To help us resolve your issue quickly, please include the following in your email:
                                </p>
                                <div className="admin-console-instructions-list">
                                    <div className="admin-console-instruction-item">
                                        <span className="admin-console-instruction-number">1</span>
                                        <span>Your name, or your school name</span>
                                    </div>
                                    <div className="admin-console-instruction-item">
                                        <span className="admin-console-instruction-number">2</span>
                                        <span>A clear description of the issue</span>
                                    </div>
                                    <div className="admin-console-instruction-item">
                                        <span className="admin-console-instruction-number">3</span>
                                        <span>The steps you took before the issue occurred</span>
                                    </div>
                                    <div className="admin-console-instruction-item">
                                        <span className="admin-console-instruction-number">4</span>
                                        <span>Any error messages you saw (a screenshot is helpful)</span>
                                    </div>
                                    <div className="admin-console-instruction-item">
                                        <span className="admin-console-instruction-number">5</span>
                                        <span>The device and browser you were using, if relevant</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Response Time Section */}
                        <div className="admin-console-section">
                            <div className="admin-console-section-header">
                                <h2 className="admin-console-section-title">Response Time</h2>
                            </div>

                            <p style={{ fontSize: "1rem", lineHeight: "1.6", marginBottom: "1.5rem" }}>
                                We aim to respond to all support enquiries <strong>within 24 hours</strong> on business days.
                                For urgent issues affecting a live event or active class, please include <strong>"URGENT"</strong> in
                                the subject line.
                            </p>

                            <div style={{ textAlign: "center", marginTop: "2rem" }}>
                                <StoreBanner />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
